<template>


  <div class="data-management-container">
    <!-- 顶部操作区 -->
    <div style="padding-bottom: 10px;text-align: left;display: block">
      <span style="color: red">访问受限后可点击访问右侧链接:</span>
<!--      <a href="https://demo.nbweiou.cn/#/DataSourse1">链接二</a>-->
      <a href="https://demo.nbweiou.cn/#/DataSourse2">链接2（100限制）</a>
    </div>
    <div class="operation-header" style="width: 62%">
      <el-input
        v-model="searchText"
        type="textarea"
        :autosize="{ minRows: 1, maxRows: 4 }"
        placeholder="请输入账户id，一行一个"
        class="search-input"
      />
      <el-select
        v-model="cookieRegion"
        placeholder="请选择地区"
      >
        <el-option label="浙江" value="zhejiang" />
        <el-option label="福建" value="fujian" />
        <el-option label="深圳星火" value="shenzhen" />
        <el-option label="苏州跃盟" value="suzhou" />
        <el-option label="广州力天" value="guangzhou" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">
        查询
      </el-button>
      <el-button type="success" icon="el-icon-circle-plus" @click="showAddDialog">
        添加事件源
      </el-button>
      <el-button
        type="warning"
        icon="el-icon-download"
        @click="exportToExcel"
        :disabled="tableData.length === 0"
      >
        导出Excel
      </el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      v-loading="loading"
    >

      <el-table-column prop="uuid" label="uuid" width="120" />
      <el-table-column label="事件源类型" width="180">
        <template slot-scope="scope">
    <span>
      <!-- 根据 type 字段的值显示汉字 -->
      {{ formatType(scope.row.type) }}
    </span>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="事件源id" width="220" />
      <el-table-column prop="name" label="事件源名称" />
      <el-table-column prop="packageName" label="包名" />
    </el-table>

    <!-- 添加数据源弹窗 -->
    <el-dialog
      title="批量添加事件源"
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleCloseDialog"
    >
      <el-form
        ref="dataForm"
        :model="formData"
        :rules="formRules"
        label-width="120px"
        label-position="right"
      >
        <!-- 新增：地区选择 -->
        <el-form-item label="选择地区：" prop="region">
          <el-select
            v-model="formData.region"
            placeholder="请选择地区"
          >
            <el-option label="浙江" value="zhejiang" />
            <el-option label="福建" value="fujian" />
            <el-option label="深圳星火" value="shenzhen" />
            <el-option label="苏州跃盟" value="suzhou" />
            <el-option label="广州力天" value="guangzhou" />
          </el-select>
        </el-form-item>

        <el-form-item label="事件源类型：" prop="sourceType">
          <el-select
            v-model="formData.sourceType"
            placeholder="请选择"
            @change="handleTypeChange"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item v-if="formData.sourceType!==2" :label="packageLabel" prop="packageName">
          <el-input
            v-model="formData.packageName"
            :placeholder="packagePlaceholder"
          />
        </el-form-item>

        <el-form-item  v-if="formData.sourceType!==2"  label="事件源名称：" prop="eventName">
          <el-input
            v-model="formData.eventName"
            placeholder="请输入事件源名称"
          />
        </el-form-item>

        <el-form-item label="账户id：" prop="batchData">
          <el-input
            v-model="formData.batchData"
            type="textarea"
            :rows="5"
            placeholder="每行一条数据"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
// 新增依赖引入
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
  data() {
    return {
      searchText: '',
      tableData: [],
      loading: false,
      dialogVisible: false,
      zjcookie: '', // 浙江的 Cookie
      fjcookie: '', // 福建的 Cookie
      szcookie: '', // 深圳星火的 Cookie
      szmcookie: '', // 苏州跃盟的 Cookie
      gzcookie: '', // 广州力天的 Cookie
      cookieRegion:'',
      formData: {
        region: '', // 新增：地区选择
        sourceType: '',
        packageName: '',
        eventName: '',
        batchData: ''
      },
      typeOptions: [
        { label: '应用', value: 1 },
        { label: '网址', value: 2 },
        { label: '快应用', value: 3 }
      ],
      formRules: {
        region: [
          { required: true, message: '请选择地区', trigger: 'change' }
        ],
        sourceType: [
          { required: true, message: '请选择事件源类型', trigger: 'change' }
        ],
        packageName: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        eventName: [
          { required: true, message: '请输入事件源名称', trigger: 'blur' }
        ],
        batchData: [
          { validator: this.validateBatchData, trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.fetchHdCookieData();
  },
  computed: {
    packageLabel() {
      const labels = {
        1: '应用包名：',
        2: '网站域名：',
        3: '快应用包名：'
      };
      return labels[this.formData.sourceType] || '包名：';
    },
    packagePlaceholder() {
      const placeholders = {
        1: '请输入应用包名（如：com.example.app）',
        2: '',
        3: '请输入快应用包名'
      };
      return placeholders[this.formData.sourceType] || '请输入包名';
    }
  },
  methods: {
    formatType(type) {
      switch (type) {
        case 1:
          return '应用';
        case 2:
          return '网址';
        case 3:
          return '快应用';
        default:
          return '未知';  // 处理其他类型或者未定义的情况
      }
    },
    // 新增导出方法
    exportToExcel() {
      // 1. 准备数据
      const data = this.processExportData();

      // 2. 创建工作簿
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "事件源列表");

      // 3. 生成文件并保存
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(blob, `事件源_${new Date().toLocaleDateString()}.xlsx`);
    },

    // 数据处理方法
    processExportData() {
      // 字段映射表
      const fieldMap = {
        uuid: 'uuid',
        type:'事件源类型',
        code: '事件源id',
        name: '事件源名称',
        packageName: '包名',
      };


      return this.tableData.map(item => {
        const formattedItem = {};
        Object.keys(fieldMap).forEach(key => {
          if (item[key] !== undefined) {
            // 处理特殊字段
            let value = item[key];


            if (key === 'type') {
              value = this.formatType(item[key]);
            }
            formattedItem[fieldMap[key]] = value;
          }
        });
        return formattedItem;
      });
    },
    // 转换 type 字段为中文
    formatType1(type) {
      const typeMapping = {
        1: '应用',
        2: '网址',
        3: '快应用'
      };
      return typeMapping[type] || '未知类型';  // 默认返回 "未知类型" 如果 type 不在映射中
    },
    // 地区值转换
    getRegionName(value) {
      const regions = {
        zhejiang: '浙江',
        fujian: '福建',
        shenzhen: '深圳星火',
        suzhou: '苏州跃盟',
        guangzhou: '广州力天'
      };
      return regions[value] || '未知地区';
    },
    async  fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('事件获取成功:', response.data);
        this.zjcookie = response.data.data.records[0].hdcookie
        this.fjcookie = response.data.data.records[1].hdcookie
        this.szcookie = response.data.data.records[2].hdcookie
        this.szmcookie = response.data.data.records[3].hdcookie
        this.gzcookie = response.data.data.records[4].hdcookie
      } catch (error) {
        console.error('错误:', error);
        this.$message.error('获取账户 Cookie 失败，请刷新页面重试');
      }
    },

    handleSearch() {

      // 处理输入的数据，去除空行
      const selectDatas = this.searchText.split('\n')
        .filter(line => line.trim())

      if (selectDatas.length <=0){
        this.$message.error('请输入uuid')
        return false
      }
      // 根据 region 选择 cookie
      if (this.cookieRegion == ''){
        this.$message.error('请先选择账号所属区域')
        return false
      }


      this.loading = true;

      const cookieMap = {
        zhejiang: this.zjcookie,
        fujian: this.fjcookie,
        shenzhen: this.szcookie,
        suzhou: this.szmcookie,
        guangzhou: this.gzcookie
      };
      const selectCookie = cookieMap[this.cookieRegion];

      // 调用异步函数
      this.fetchData(selectDatas, selectCookie);
    },
    async fetchData(selectDatas, selectCookie) {
      let mergedData = [];  // 用于存储合并后的数据
      const failList = [];  // 记录查询失败的账户，避免表格空白时看不出原因

      // 遍历 selectDatas 发送请求
      for (let i = 0; i < selectDatas.length; i++) {
        const subId = selectDatas[i];
        try {
          const encodedCookie = btoa(`${selectCookie}; b_marketing_subid=${subId}`);
          const res = await axios.get(`https://control.zjwec.cn/api/vivo/queryEventData?cookie=${encodedCookie}`);

          if (res.data.message !== '操作成功') {
            failList.push({ subId: subId, reason: res.data.message || '查询失败' });
            continue;
          }

          // 为每个对象添加 uuid 属性
          const dataWithUuid = (res.data.data || []).map(d => ({
            ...d,  // 保留原有的属性
            uuid: subId  // 添加 uuid 属性
          }));

          // 合并数据
          mergedData = mergedData.concat(dataWithUuid);
        } catch (error) {
          failList.push({ subId: subId, reason: this.formatRequestError(error) });
        }
      }

      // 更新 tableData 和 loading 状态
      this.tableData = mergedData;
      this.loading = false;

      if (failList.length === 0) {
        return;
      }
      // 全部失败且原因相同（比如 Cookie 失效）时只提示一条，避免刷一屏重复信息
      const reasons = [...new Set(failList.map(item => item.reason))];
      const message = mergedData.length === 0 && reasons.length === 1
        ? `全部 ${failList.length} 个账户查询失败：${reasons[0]}`
        : failList.map(item => `${item.subId}：${item.reason}`).join('；');
      this.$alert(message, mergedData.length === 0 ? '查询失败' : `部分账户查询失败（${failList.length} 个）`, {
        type: mergedData.length === 0 ? 'error' : 'warning',
        confirmButtonText: '知道了'
      });
    },
    showAddDialog() {
      this.dialogVisible = true;
    },
    handleTypeChange() {
      this.formData.packageName = '';
    },

    handleSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          // 根据选择的地区输出对应的 Cookie
          const cookieMap = {
            zhejiang: this.zjcookie,
            fujian: this.fjcookie,
            shenzhen: this.szcookie,
            suzhou: this.szmcookie,
            guangzhou: this.gzcookie
          };
          const regionCookie = cookieMap[this.formData.region];
          const datas = this.parseBatchData();

          // 使用 async/await 处理异步请求
          this.submitData(datas, regionCookie);
        }
      });
    },

    async submitData(datas, regionCookie) {
      const successList = [];
      const failList = [];
      const eventName = this.formData.sourceType === 2 ? '网址' : this.formData.eventName;

      // 逐个账户处理，单个失败不影响剩余账户
      for (let i = 0; i < datas.length; i++) {
        const subId = datas[i];
        try {
          const requestData = {
            cookie: `${regionCookie}; b_marketing_subid=${subId}`,
            type: this.formData.sourceType,
            packageName: this.formData.sourceType == 2 ? '' : this.formData.packageName,
            name: eventName,
          };

          const postRes = await this.sendEventData(requestData);
          if (postRes.data.message !== '操作成功') {
            // 名称重复说明该账户下已有同名事件源，别提示成“创建失败”让人反复重试
            if (postRes.data.message === '名称重复') {
              failList.push(`${subId}：事件源「${eventName}」已存在（名称重复），本次跳过`);
            } else {
              failList.push(`${subId}：创建事件源失败（${postRes.data.message || '未知原因'}）`);
            }
            continue;
          }

          const queryRes = await this.queryEventData(regionCookie, subId);
          const sourceList = (queryRes.data && queryRes.data.data) || [];
          const targetObject = sourceList.find(item => item.name === eventName);

          if (!targetObject) {
            failList.push(`${subId}：事件源已创建，但查询列表里找不到「${eventName}」，无法挂事件`);
            continue;
          }

          const batchRes = await this.sendBatchEventData(regionCookie, subId, targetObject.code);
          if (batchRes.data.message === '操作成功') {
            successList.push(subId);
          } else {
            // 事件源已经建出来了，重跑会撞名称重复，提示里要写清楚当前状态
            failList.push(`${subId}：事件源已创建（${targetObject.code}），挂事件失败（${batchRes.data.message || '未知原因'}），请勿重复添加`);
          }
        } catch (error) {
          failList.push(`${subId}：${this.formatRequestError(error)}`);
        }
      }

      this.dialogVisible = false;

      if (failList.length === 0) {
        this.$message.success(`全部成功：${successList.length} 个账户`);
        return;
      }
      this.$alert(failList.join('；'), `完成：成功 ${successList.length} 个，失败 ${failList.length} 个`, {
        type: 'warning',
        confirmButtonText: '知道了'
      });
    },

    // 后端 500 会把原因放在响应体的 error 字段，axios 自带的 message 只有英文状态码
    formatRequestError(error) {
      const responseData = error && error.response && error.response.data;
      if (responseData && responseData.error) {
        return responseData.error;
      }
      return (error && error.message) || '请求异常';
    },

// 封装发送 EventData 的请求
    sendEventData(requestData) {
      return axios.post('https://control.zjwec.cn/api/vivo/sendEventData', requestData);
    },

// 封装查询 EventData 的请求
    async queryEventData(regionCookie, subId) {
      const encodedCookie = btoa(`${regionCookie}; b_marketing_subid=${subId}`);
      const url = `https://control.zjwec.cn/api/vivo/queryEventData?cookie=${encodedCookie}`;
      return axios.get(url);

    }
,


// 封装发送批量 EventData 的请求
    sendBatchEventData(regionCookie, subId, srcId) {
      return axios.post('https://control.zjwec.cn/api/vivo/sendBatchEventData', {
        cookie: `${regionCookie}; b_marketing_subid=${subId}`,
        srcId: srcId
      });
    },
    parseBatchData() {
      return this.formData.batchData
        .split('\n')
        .filter(line => line.trim())

    },
    handleCloseDialog() {
      this.$refs.dataForm.resetFields();
    },
    validateBatchData(rule, value, callback) {
      const lines = value.split('\n').filter(l => l.trim());
      if (lines.length === 0) return callback();


      const isValid = lines.every(line => {
        const trimmed = line.trim(); // 去掉前后空格
        return trimmed.length > 0 && /^[a-zA-Z0-9]+$/.test(trimmed); // 检查是否只包含字母或数字
      });

      isValid
        ? callback()
        : callback(new Error('注意检查格式'));
    },

  }
};
</script>

<style scoped>
.data-management-container {
  padding: 20px;
  background: #f5f7fa;
}

.operation-header {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.search-input {
  flex: 1;
}

.search-input ::v-deep .el-textarea__inner {
  resize: none;
  line-height: 1.5;
}

.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/login/DataSourse.vue